module.exports = __webpack_public_path__ + "img/backoffice.9336ede5.gif";